import posthog from 'posthog-js';
import { analyticsOptOut } from './utils/privacy';

// Initialize PostHog with EU-compliant settings
if (typeof window !== 'undefined' && import.meta.env.VITE_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false,
    respect_dnt: true,
    secure_cookie: true,
    ip: false,
    disable_session_recording: false,
    ui_host: 'https://eu.posthog.com',
    loaded: function(posthog) {
      if (analyticsOptOut.hasOptedOut()) {
        posthog.opt_out_capturing();
      }
    }
  });
}

// Export actively used events
export { trackPageView } from './events/pageView';
export { trackSearchApps } from './events/searchApps';
export { trackSearchRequests } from './events/searchRequests';
export { trackVoteRequest } from './events/voteRequest';
export { trackSubmitRequest } from './events/submitRequest';
export { trackViewRequestDetails } from './events/viewRequestDetails';
export { trackGenerateSharePost } from './events/generateSharePost';
export { trackChangeSort } from './events/changeSort';
export { trackChangeFilter } from './events/changeFilter';
export { trackSignIn } from './events/signIn';
export { trackSignOut } from './events/signOut';
export { identify } from './events/identify'; 